(function($) {
    // Homepage Script
    if($('body').hasClass('template-index')) {
        $('.section-text-columns-with-images .column-container').slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                        arrow: true
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    // Featured List Collection
    $('.featured-collection.collection-list').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        arrow: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    if($('body').hasClass('template-sfx-monthly-fruit-club')) {
        $('.theme-product-reviews-full').insertAfter('.section-text-columns-with-images');
    }


    if ($("#gsMultishippingPage")[0]){
        $("#gs__toggle-box").append("<a class=\"more-link left\" href=\"/\">Continue shopping</a>");
    }

    // Product Page
    if($('body').hasClass('template-product')) {
        setTimeout(function() {
            jQuery('body').on('click', '.product-add-ons > .gpo-label', function () {
                jQuery(this).parent().toggleClass('active');
            });
        }, 500);

        setTimeout(function() {
            if(jQuery('.gpo-element').hasClass('product-add-ons')) {
                jQuery('h2.add-ons-title').addClass('with-add-ons');
            }
        }, 1200);
    }

    setTimeout(function() {
        $('body').on('click', '.footer-columns .links-column .menu-title', function () {
            $(this).parent('.links-column').toggleClass('active');
        });
    }, 500);

    if($('body').hasClass('template-sfx-fruit-encyclopedia')) {
        $('.section-text-columns-with-images .column-container').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrow: true,
            speed: 250,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    const shippingDropdown = $('.gs__shipping-rate-container');
    console.log(shippingDropdown.length);

    // For auto checking the is this a gift of GiftShipping
    if($('body').hasClass('template-cart')) {

        document.addEventListener('giftship.loaded', function() {
            $(".gs__gift-checkbox").prop('checked', true);
            $(".gs__toggle-feature-item").removeClass('gs__collapsed');
        });

    }

    // Product Page GiftShip Add-on Override and Price Updater
    $(document).ready(function(){
        if($('#gsMultishippingPage').length){
            // Disclaimer && Warning for Shipping Page
            document.querySelector('#gsGroup1 .gs__cart-header tr th').innerHTML = '<h3 class="checkout-disclaimer_text" style="font-size: 1em!important">Order by 12p PST (M-F) ships same day</h3>';

            const shipping_method_title = document.querySelectorAll('.gs__group fieldset.gs__content-box legend.gs__visually-hidden');
            for (let i = 0; i < shipping_method_title.length; i++) {
                shipping_method_title[i].innerText = 'Choose Shipping Method';
            }

            $(document).on('click', '#gsAppContainer .gs__product-option li', function(event){
                updatedPrice = origPrice; // Resets to base price everytime an add-on is clicked

                if(!$(this).find('input:checkbox').prop('checked') == true) { // Checks if clicked add-on checkbox is not yet checked
                    $(this).parents('.gs__product-option').find('input:checkbox').each(function(){ // Runs through all add-ons of the same group
                        var data_id = $(this).attr('value'); // Stores ID current checkbox iteration

                        $(this).prop('checked', false); // Unchecks all checkbox iteration

                        $('#gsBundlePrices').children().each(function(){ // Runs through all selection that are already added
                            if($(this).attr('data-id') == data_id) { // Cross-checks ID match to remove existing addon from the same group
                                $(this).remove();
                            }
                        });
                    });

                    $(this).find('input:checkbox').prop('checked', true); // Sets clicked add-on checkbox to check

                    // Adds current add-on to the selection
                    if(!$('#gsBundlePrices input[data-id="' + $(this).find('input:checkbox').attr('value') + '"]').length) {
                        $('<input type="hidden" name="properties[_gs_bundle_prices][]" value="' + $(this).find('input:checkbox').attr('data-bundle-cents') + '" data-id="' + $(this).find('input:checkbox').attr('value') + '"/>').appendTo('#gsBundlePrices');
                        $('<input type="hidden" name="properties[_gs_bundle_contents][]" value="' + $(this).find('input:checkbox').attr('data-child-option-name') + '" data-id="' + $(this).find('input:checkbox').attr('value') + '"/>').appendTo('#gsBundlePrices');
                    }
                } else {
                    $(this).find('input:checkbox').prop('checked', false); // Unchecks current clicked add-on
                    $('#gsBundlePrices').find('input[data-id="' + $(this).find('input:checkbox').attr('value') + '"]').remove(); // Removes from selection
                }

                // Calculates updated price upon add-on selection
                var addonTotal = 0;
                $('#gsBundlePrices input').each(function(){
                    if($(this).attr('name') == 'properties[_gs_bundle_prices][]') {
                        addonTotal += parseInt($(this).attr('value'));
                    }
                });

                updatedPrice = ((origPrice + addonTotal) / 100).toFixed(2);
                $('.current-price').text('$' + updatedPrice); // Updates price in frontend

                return false;
            });
        }

        if($('body').hasClass('template-product')) {
            // Sets Product Base Price on load
            var origPrice = parseInt($('.current-price').text().replace('$', '')) * 100,
                updatedPrice = origPrice;
        }
    });
    //Added by Mubeen
    $(".gs__address-modal-body input[type=text], .gs__address-modal-body textarea").attr("autocomplete", "do-not-autofill");
    $("<button class='form_clear' id='clear_form_button'>Clear Form</button>").insertBefore("button.gs__close-modal:not('.gs__close-address')");
    $('.gs__modal-footer').on('click','#clear_form_button',function(){
        $(".gs__address-modal-body input[type=text], .gs__address-modal-body textarea").val("").attr("autocomplete", "do-not-autofill");
        $(".gs__address-modal-body select").prop('selected', false);
        $("select#gsNewProvince").val($("select#gsNewProvince option:first").val());
    });
    setTimeout(function(){
        $(".gs__address-modal-body input[type=text]").attr("autocomplete", "do-not-autofill");
    },2500);
})(jQuery);

setTimeout(() => {
    // const toMesssageField = document.querySelector(".template-cart #to_message")
    // toMesssageField.value = "dummy"

    const toMessageFields = document.querySelectorAll("[placeholder='To']")
    toMessageFields.forEach((field) => {
        console.log(field)
        field.value = "N/A"
    })

}, 4000)

